// Grayscale Adobe Firefly mark. Vendored from public/logo-firefly.svg with the
// corporate-red badge dropped and the "Fi + sparkle" glyph filled with
// currentColor, so it renders as a monochrome icon that sits inside the round
// hover-rail button exactly like the other line icons (download, replace).
// The viewBox is cropped to the glyph bounds so it centers and sizes to match.
// `slot="icon"` is load-bearing: Spectrum's ActionButton only collapses its
// horizontal padding to a square icon-only button when its child matches
// `:has([slot=icon])`. Without it the button renders as a wider pill.
export const FireflyIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			slot="icon"
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="3.6 1.3 48 48"
			fill="currentColor"
			aria-hidden="true"
			className={className}
		>
			<path d="M13.48,14.96h18.09v5.88h-11.21v4.25h9.92v5.88h-9.92v8.77h-6.88V14.96Z" />
			<path d="M34.46,20.43h6.48v19.32h-6.48v-19.32Z" />
			<path d="M38.81,16.86l2.31.52c.91.2,1.54-.88.9-1.56l-1.6-1.73c-.21-.23-.3-.54-.23-.85l.52-2.3c.2-.9-.88-1.53-1.57-.9l-1.74,1.6c-.23.21-.55.29-.85.23l-2.31-.52c-.91-.2-1.54.88-.9,1.56l1.6,1.73c.21.23.3.54.23.85l-.52,2.3c-.2.9.88,1.53,1.57.9l1.74-1.6c.23-.21.55-.29.85-.23Z" />
		</svg>
	);
};
